// https://react-dropzone.js.org/#section-styling-dropzone

import React, { useMemo } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
};

const activeStyle = {
    borderColor: '#2196f3',
};

const acceptStyle = {
    borderColor: '#00e676',
};

const rejectStyle = {
    borderColor: '#ff1744',
};

interface StyledDropzoneProps {
    caption: string;
    name: string;
    onDrop: any;
}

export const StyledDropzone: React.FC<StyledDropzoneProps & DropzoneOptions> = ({
    name,
    caption,
    accept,
    onDrop,
}) => {
    const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
        accept,
        onDrop,
    });

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
            width: '500px',
        }),
        [isDragActive, isDragReject, isDragAccept],
    );

    return (
        <div className="container">
            {/* @ts-ignore */}
            <div {...getRootProps({ style })}>
                <input name={name} {...getInputProps()} />
                <p>{caption}</p>
            </div>
        </div>
    );
};
